namespace Matrix {
    export interface AboutResponse extends Serenity.ServiceResponse {
        Environment?: string;
        Version?: string;
        Dependencies?: { [key: string]: string };
        DatabaseName?: string;
        DatabaseUser?: string;
        InstalledModules?: string[];
        UserRoles?: string[];
    }
}
